import { render, staticRenderFns } from "./shiYanTanJiu.vue?vue&type=template&id=2319fe9c&scoped=true&"
import script from "./shiYanTanJiu.vue?vue&type=script&lang=js&"
export * from "./shiYanTanJiu.vue?vue&type=script&lang=js&"
import style0 from "./shiYanTanJiu.vue?vue&type=style&index=0&id=2319fe9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319fe9c",
  null
  
)

export default component.exports